import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Login from './components/Login';
import VeGa from './components/VeGa';
import VeGaSettings from './components/VeGaSettings';
import VeGaRides from './components/VeGaRides';
import BikeConfigPage from './pages/BikeConfigPage';
import Bikes from './components/Bikes';
import BikeMaintenancePage from './pages/BikeMaintenancePage';
import VegaMaintenance from './components/VegaMaintenance';
import Home from './components/Home';
import Moscht from './components/Moscht';
import MoschtEvents from './components/MoschtEvents';
import MoschtLogs from './components/MoschtLogs';
import MoschtTankungen from './components/MoschtTankungen';
import MoschtCars from './components/MoschtCars';
import MoschtSettings from './components/MoschtSettings';
import WorkSettings from './components/WorkSettings';
import WorkDashboard from './components/WorkDashboard';
import WorkoutDashboard from './components/WorkoutDashboard';
import WorkoutList from './components/WorkoutList';
import WorkoutExercises from './components/WorkoutExercises';
import Run from './components/Run';
import Profile from './components/Profile';
import LearningCards from './components/LearningCards';
import LearningCardSet from './components/LearningCardSet';
import LearningCardStudy from './components/LearningCardStudy';
import LearningCardsHistory from './components/LearningCardsHistory';
import PrivateRoute from './components/PrivateRoute';
import AppNavigation from './navigation/AppNavigation';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <AppNavigation />
              </PrivateRoute>
            }
          >
            <Route index element={<Home />} />
            <Route path="/dashboard/vega" element={<VeGa />} />
            <Route path="/dashboard/vega/rides" element={<VeGaRides />} />
            <Route path="/dashboard/vega/maintenance" element={<VegaMaintenance />} />
            <Route path="/dashboard/vega/settings" element={<VeGaSettings />} />
            <Route path="/dashboard/moscht" element={<Moscht />} />
            <Route path="/dashboard/moscht/events" element={<MoschtEvents />} />
            <Route path="/dashboard/moscht/logs" element={<MoschtLogs />} />
            <Route path="/dashboard/moscht/tankungen" element={<MoschtTankungen />} />
            <Route path="/dashboard/moscht/cars" element={<MoschtCars />} />
            <Route path="/dashboard/moscht/settings" element={<MoschtSettings />} />
            <Route path="/dashboard/work" element={<WorkDashboard />} />
            <Route path="/dashboard/work-settings" element={<WorkSettings />} />
            <Route path="/dashboard/workouts" element={<WorkoutDashboard />} />
            <Route path="/dashboard/workouts-list" element={<WorkoutList />} />
            <Route path="/dashboard/workout-exercises" element={<WorkoutExercises />} />
            <Route path="/dashboard/learning-cards" element={<LearningCards />} />
            <Route path="/dashboard/learning-cards/history" element={<LearningCardsHistory />} />
            <Route path="/dashboard/learning-cards/:setId" element={<LearningCardSet />} />
            <Route path="/dashboard/learning-cards/:setId/study" element={<LearningCardStudy />} />
            <Route path="/dashboard/run" element={<Run />} />
            <Route path="/dashboard/profile" element={<Profile />} />
          </Route>
          <Route path="/" element={<Navigate to="/dashboard" />} />
          <Route
            path="/bike"
            element={
              <PrivateRoute>
                <AppNavigation />
              </PrivateRoute>
            }
          >
            <Route index element={<Bikes />} />
            <Route path="settings" element={<BikeConfigPage />} />
            <Route path="maintenance" element={<BikeMaintenancePage />} />
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
